/*
 * @Description:
 * @Date: 2019-12-31 14:53:59
 */

//所有场景只由projectAllList维护
import { projectAllList } from '@/config/staticData';
import { setStorage, getStorage } from '@/tools/storage';
import { projectInfoNew } from '@/api/ajax';

// 整理每个场景编辑详情对应的组件、名称等
const customInfo = projectAllList.reduce((pre, cur) => {
  pre[cur.projectType] = {
    editName: cur.filePath + 'Detail',
    recordName: cur.filePath + 'Record',
    projectTypeName: cur.name,
    projectDefaultBg: cur.projectDefaultBg
  };
  return pre;
}, {});

const createFields = (projectInfo = {}) => {
  const { editName, recordName, projectTypeName, projectDefaultBg } =
    customInfo[projectInfo.projectType] || {};

  return {
    activeName: 'first',
    projectType: projectInfo.projectType || '', // 项目类型 1学术拜访 2 OTC巡访 3 科室会 4 患教会 5助手端项目调研 6线上推广 7医生端调查问卷 8医生病历  9 等级医院拜访  10基层医疗机构拜访 11 特级三甲医院市场准入  12 三级医院市场准入  13 二级医院市场准入  14 基层医疗机构市场准入 15 零售药店市场准入 17数字拜访 18助手病历征集 19协定服务 20可配场景 21数字问卷
    projectName: projectInfo.projectName || '',
    id: projectInfo.id || '',
    editName, // 编辑显示组件
    recordName, // 任务记录组件名, 后缀额外添加了Record拼接，例：accessSuperRecord
    projectTypeName:
      projectInfo.projectType == 20
        ? projectInfo.serviceSubitem
        : projectTypeName, // 对应项目名称
    serviceSubitem: projectInfo.serviceSubitem || '',
    doctorOrHelperType: projectInfo.doctorOrHelperType || 1, // 1医生2助手 新增字段，代替type
    type: projectInfo.doctorOrHelperType || projectInfo.type || 1, // 1医生2助手
    projectStructureType: projectInfo.projectStructureType || '', //新增项目类型，1代表四级结构，2代表三级个体，3代表三级个人
    projectDefaultBg,
    taxCollectionPattern: projectInfo.taxCollectionPattern || '', // 税筹结构  1 汇总申报  2 委托代开(线下)  3 委托代发  4 运营基地  5 个体  6 委托代开(线上)   9  工具
    userEnterpriseType: projectInfo.userEnterpriseType || 1, // 1自然人 2个体 3园区个体
    userEnterpriseParkName: projectInfo.userEnterpriseParkName || '', // 园区名
    userEnterpriseParkId: projectInfo.userEnterpriseParkId || 0, // 园区id
    userEnterpriseParkCode: projectInfo.userEnterpriseParkCode || '', // 园区code
    fileUpMode: projectInfo.fileUpMode || 0, // 1活动维度 2人维度 mode是source子类型
    fileUpSource: projectInfo.fileUpSource || 0, // 1ASP上传 2C上传 3双方上传
    isAuditCso: projectInfo.isAuditCso || 0, // 审核人cso是否可见 0 不可见   1 可见
    baseOperateBaseData: projectInfo.baseOperateBaseData || 0, // 该企业是否运营基地 0否 1是
    whetherExcelHasBeenImported: projectInfo.whetherExcelHasBeenImported || 0, // 是否导入过excel 0否1是
    projectTaskPlan: projectInfo.projectTaskPlan || '', // 格式 2021-07-14  预采购日期
    answerMode: projectInfo.answerMode || null, // 问答模式 // 1 自答 2 分享
    isExcessAudit: projectInfo.isExcessAudit || 0, // 超量审核 0未开启
    taskShowType: projectInfo.taskShowType || null,
    payPassagewayCode: projectInfo.payPassagewayCode, // 支付通道
    projectCooperateMode: projectInfo.projectCooperateMode, // 1 招标 2协商
    auditStatus: projectInfo.auditStatus, // 审核状态 0未提交审核  1审核中  2审核未通过  3审核通过。
    businessType: projectInfo.businessType, // 业务结构   1 四级汇总  2 三级汇总  3 三级代开  4 二级代开 5 三级灵工 6 二级灵工 7 三级个体 8 二级个体 9 工具 10 三级代开(云代开) 11 二级代开(云代开)
    patternType: projectInfo.patternType, // 具体模式 1 工业-ASP-P-C  2 工业-P-C  3 ASP-P-C  4 工业-ASP-C 5 工业-C  6 ASP-C  7 工业-运营基地-C  8 ASP-运营基地-C  9 运营基地-C   10 工业-ASP-个体 11 工业-个体 12 ASP-个体   13工业-ASP(线下支付)-P-C    14工业(线下支付)-P-C 15ASP(线下支付)-P-C
    isBusinessScale: projectInfo.isBusinessScale || 0, //  是否包含商务服务费 大于0包含
    isNeedCertification: projectInfo.isNeedCertification || 0, // 是否包含商务服务费 大于0包含
    certificationClassifyList: projectInfo.certificationClassifyList || [] // 资质要求
  };
};
const homeProject = {
  state: createFields(),
  mutations: {
    SET_ACTIVENAME: (state, item) => {
      state.activeName = item;
    },
    SET_HOME_QUERY: (state, info) => {
      state = Object.assign(state, createFields(info));
      // 为了兼容部分组件使用了缓存获取
      setStorage('homeProject', state);
    },
    // 初始化 项目信息
    INIT_PROJECT_STATE: (state, exclude = 'activeName') => {
      Object.keys(state).filter(key => {
        if (key !== exclude) {
          state[key] = '';
        }
      });
      localStorage.homeProject = '';
    }
  },
  actions: {
    // 同步项目信息
    async syncProjectInfo({ commit, state }, info = {}) {
      const storage = getStorage('homeProject'); // 防止部分页面没有id或者type
      const { id, type, projectId, projectType } = info;
      const _projectId = projectId || id || state.id || storage.id;
      const _projectType =
        projectType || type || state.projectType || storage.projectType;
      if (_projectId && _projectType) {
        try {
          const resp = await projectInfoNew({
            projectId: _projectId,
            projectType: _projectType
          });
          const data = { ...info, ...resp.pdata };
          commit('SET_HOME_QUERY', data);
          return Promise.resolve(data);
        } catch (e) {
          console.error(`syncProjectInfo error: ${e}`);
          return Promise.reject(e);
        }
      }
    },
    setActivename({ commit }, item) {
      commit('SET_ACTIVENAME', item);
    }
  }
};
export default homeProject;
